import { useMemo } from "react";

export const useConnection = () => {
  const IsServerConnected = useMemo(() => {
    return window.navigator.onLine;
  }, []);

  return { IsServerConnected };
};
